import { useEffect } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { useParams, useHistory } from 'react-router';
import { useSnackbar } from 'notistack';

import masterServicesApi from '../../../../apis/master-services';

import LoadingServiceDetails from '../../components/Loading/LoadingServiceDetails';
import ServiceConditionForm from './ServiceConditionForm';
import { queryClient } from '../../../QueryClientProvider/QueryClientProvider';

export default function ServiceDetails() {
  const history = useHistory();
  const { conditionId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const isNewCondition = conditionId === 'create';

  const { data: condition, isFetched, isError: errorFetchingCondition } = useQuery({
    queryKey: ['service-condition', conditionId],
    queryFn: ({ queryKey }) => masterServicesApi.getServiceCondition(queryKey[1]),
    enabled: !isNewCondition,
    meta: { errorMessage: 'Failed to fetch condition' },
  });

  const { mutate: upsertServiceCondition } = useMutation({
    mutationFn: masterServicesApi.upsertServiceCondition,
    onSuccess: (updatedCondition, variables) => {
      queryClient.setQueryData(['service-condition', updatedCondition._id], updatedCondition);
      enqueueSnackbar(`Condition successfully ${variables._id ? 'updated' : 'created'}`, { variant: 'success' });
      if (!variables._id) history.push(updatedCondition._id);
    }
  });

  const { mutate: deleteCondition } = useMutation({
    mutationFn: masterServicesApi.deleteServiceCondition,
    onSuccess: () => {
      enqueueSnackbar('Condition successfully deleted', { variant: 'success' });
      history.push('/services/conditions');
    },
  })

  useEffect(() => {
    if (errorFetchingCondition) history.push('/services/conditions');
  }, [errorFetchingCondition, history]);

  if (!isNewCondition && !isFetched) return <LoadingServiceDetails />

  return (
    <ServiceConditionForm
      condition={condition}
      upsertServiceCondition={upsertServiceCondition}
      deleteCondition={deleteCondition}
    />);
}
